/* Description: Cursor ripple animation 
   Author: Sahil Ahlawat
   Updated On: 30/Jan/25
   Created On: 30/Jan/25
   ========================================================================== */

   document.addEventListener('DOMContentLoaded', function() {
    const searchBoxes = document.querySelectorAll('.ps-jobsearchbox');

    searchBoxes.forEach(searchBox => {
        const inputField = searchBox.querySelector('.job-keyword-search');
        if (!inputField) return;

        const keywordWrapper = searchBox.querySelector('.keywordwrapper');
        const dropdown = keywordWrapper.querySelector('.jobkeyworddropdown');
        const clearButton = document.createElement('button');
        clearButton.className = 'clear-button';
        clearButton.innerHTML = '×';
        clearButton.setAttribute('aria-label', 'Clear input');
        clearButton.style.display = 'none';
        keywordWrapper.appendChild(clearButton);

        let timeout = null;

        // Toggle 'active' class on input focus
        inputField.addEventListener('focus', function() {
            const keyword = inputField.value.trim();
            fetchResults(keyword);
            clearButton.style.display = 'inline';
            dropdown.classList.add('active'); // Add 'active' class when input is focused
        });

        inputField.addEventListener('input', function() {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                fetchResults(inputField.value);
            }, 300); // Throttle API calls to every 300ms
            clearButton.style.display = inputField.value ? 'inline' : 'none';
        });

        clearButton.addEventListener('click', function(event) {
            event.preventDefault();
            inputField.value = '';
            clearButton.style.display = 'none';
            dropdown.innerHTML = '';
            dropdown.classList.remove('active'); // Remove 'active' class when clearing input
            inputField.focus();
        });

        clearButton.addEventListener('keydown', function(event) {
            if (event.key === 'Tab' && !event.shiftKey) {
                dropdown.innerHTML = '';
                dropdown.classList.remove('active'); // Remove 'active' class on tab away
                clearButton.style.display = 'none';
            }
        });

        inputField.addEventListener('keydown', function(event) {
            if (event.key === 'ArrowDown') {
                const firstItem = dropdown.querySelector('.dropdown-item');
                if (firstItem) {
                    firstItem.focus();
                }
            }
        });

        dropdown.addEventListener('keydown', function(event) {
            if (event.key === 'ArrowDown') {
                const nextItem = event.target.nextElementSibling;
                if (nextItem) {
                    nextItem.focus();
                }
            } else if (event.key === 'ArrowUp') {
                const prevItem = event.target.previousElementSibling;
                if (prevItem) {
                    prevItem.focus();
                } else {
                    inputField.focus();
                }
            } else if (event.key === 'Enter') {
                event.target.click();
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(event) {
            if (!keywordWrapper.contains(event.target)) {
                dropdown.innerHTML = '';
                dropdown.classList.remove('active'); // Remove 'active' class when clicking outside
            }
        });

        function fetchResults(keyword) {
            fetch(`${siteData.siteUrl}/wp-json/jobs/v1/jobs-search-keyword?keyword=${encodeURIComponent(keyword)}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    renderDropdown(data);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    renderDropdown([]); // Clear dropdown on error
                });
        }

        function renderDropdown(items) {
            dropdown.innerHTML = '';
            const ul = document.createElement('ul');
            ul.className = 'dropdown-list';

            items.forEach(item => {
                const li = document.createElement('li');
                li.className = 'dropdown-item';
                li.textContent = item;
                li.setAttribute('tabindex', '0');
                li.addEventListener('click', function() {
                    inputField.value = item;
                    dropdown.innerHTML = '';
                    dropdown.classList.remove('active'); // Remove 'active' class when selecting an item
                });
                ul.appendChild(li);
            });

            dropdown.appendChild(ul);
        }
    });
});
